// export const subscription = [
// 	{
// 		subscriptionType: "Basic (Free Forever)",
// 		price: "0",
// 		description:
// 			"Our Basic Plan is the perfect entry point for those seeking essential features to get started.",
// 		features: [
// 			"Messages and create/join 2 communities only",
// 			"Post updates and articles",
// 			"Search startup's",
// 			"Founders Build portfolio",
// 		],
// 	},
// 	{
// 		subscriptionType: "Pro",
// 		price: "20000",
// 		description:
// 			"The Advance plan is the pinnacle of our offerings, meticulously curated for those who demand excellence in every aspect.",
// 		features: [
// 			"Messages and communities unlimited",
// 			"Post updates and articles",
// 			"Search startup's, founders, Investors",
// 			"Build portfolio",
// 			"Get one link",
// 			"Share over 32+ documents",
// 			"Pitch day, startup/ investors event access",
// 			"KYC Verification and verified startups",
// 			"Find investors",
// 			"Share one link with investors",
// 			"Sponsored  deal",
// 			"Investment partner",
// 			"One on one consultation",
// 		],
// 	},
// 	{
// 		subscriptionType: "Standard",
// 		price: "10000",
// 		description:
// 			"Step up your game with our Pro Plan designed for those who demand more from their experience.",
// 		features: [
// 			"Messages and communities unlimited",
// 			"Post updates and articles",
// 			"Search startup's, founders",
// 			"Build portfolio",
// 			"Get one link",
// 			"Share over 32+ documents",
// 			"Pitch day, startup/ investors event access",
// 			"KYC Verification and verified startups",
// 			"Free one on one consulting",
// 		],
// 	},
// ];

// export const contactPrice = [
// 	{
// 		subscriptionType: "Pro Basic",
// 		price: "1999",
// 		description:
// 			"Our Pro Basic Plan is the perfect entry point for those seeking essential features to get started.",
// 		features: [
// 			"Can view emails of investors",
// 			"Messages and create/join 2 communities only",
// 			"Post updates and articles",
// 			"Search startup's",
// 			"Founders Build portfolio",
// 		],
// 	},
// ];

export const plans = [
	// {
	// 	subscriptionType: "Basic",
	// 	price: "0",
	// 	description:
	// 		"Our Basic Plan is the perfect entry point for those seeking essential features to get started.",
	// 	features: [
	// 		"Founder profile",
	// 		"Startup profile",
	// 		"Unlimited Posts",
	// 		"Explore Startup, Investor and VC's",
	// 		"Create One Link",
	// 		"Unlock resources : Pitch deck playbook, sales playbook, GTM playbook, Marketing Playbook and Financial modeling Playbook",
	// 	],
	// },
	// {
	// 	subscriptionType: "Standard",
	// 	price: "1999",
	// 	description:
	// 		"The Advance plan is the pinnacle of our offerings, meticulously curated for those who demand excellence in every aspect.",
	// 	features: [
	// 		"Contact info of 2000+ angel investors and 250+ VC's",
	// 		"Create unlimited communities",
	// 		"Sell Digital products",
	// 		"Create meetings, events and webinars",
	// 		"Book appointments with industry leaders",
	// 		"Publish One Link",
	// 		"And all features from previous plan",
	// 	],
	// },
	{
		subscriptionType: "Pro",
		price: "20000",
		discountedPrice: "10000",
		description:
			"Our most comprehensive plan with premium features for serious business growth and investor outreach.",
		features: [
			"Reach out to 1000+ investors in a click",
			"100 mail per week",
			"Dedicated support",
			"Everything in standard"
		],
	},
];
